import type { AxiosError } from 'axios';
import { createMutation } from 'react-query-kit';

import { client, queryClient } from '@/api/common';
import type { Admin } from '@/api/partners/admins/types';
import { useAdmin } from '@/api/partners/admins/use-admin';

type Variables = void;
type Response = {
  data: {
    unreadChangelogCount: number;
  };
};

export const useMarkChangelogsViewed = createMutation<
  Response,
  Variables,
  AxiosError
>({
  mutationFn: async () =>
    client({
      url: 'v2/internal/partners/changelogs/mark_viewed',
      method: 'POST',
    }).then((response) => response.data),
  onSuccess: (result) => {
    queryClient.setQueryData(
      useAdmin.getKey(),
      (current: Admin | undefined) => {
        if (!current) {
          return current;
        }

        return {
          ...current,
          unreadChangelogCount: result.data.unreadChangelogCount ?? 0,
        };
      }
    );
  },
});
